<template>
  <div class="container-options">
    <transition
      enter-class="opacity-0"
      leave-class="opacity-40"
      enter-to-class="opacity-40"
      leave-to-class="opacity-0"
    >
      <div v-if="website && dropdownPosition && comp" class="absolute duration-100 left-0 top-0 w-full h-full opacity-30 bg-black z-30" @click="closeContainer"></div>
    </transition>

    <div class="opacity-0 h-0 invisible hidden">
      {{ dropdownPosition }}
      {{ comp }}
      {{ target }}
      {{ iframeRect }}
      {{ initialValue }}
    </div>
    <transition
      enter-class="mt-2 opacity-0"
      leave-class="mt-0 opacity-100"
      enter-to-class="mt-0 opacity-100"
      leave-to-class="mt-2 opacity-0"
    >
      <div
        v-if="website && dropdownPosition && comp"

        class="absolute duration-300 border border-gray-200 bg-white shadow-lg z-40 rounded-lg"
        :class="shouldCentralize && 'left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2'"

        :style="dropdownPosition"
      >
        <component
          :is="comp"

          :websiteUid="website.uid"
          :value="initialValue"
          @close="closeContainer"
          @set-value="setValue"
          v-bind="bind"
        />
      </div>
    </transition>
  </div>
</template>

<script>

import ImageManager from "@/components/SideEditor/ContainerOptions/ImageManager"
import TextInput from "@/components/SideEditor/ContainerOptions/TextInput"
import LinkInput from "@/components/SideEditor/ContainerOptions/LinkInput"

import { mapState, mapGetters } from "vuex"

import {mapObject, unmappObject} from "@/utils/editor"

export default {
  components: {
    LinkInput,
    ImageManager,
    TextInput,
  },
  created() {
    console.log(this.initialValue)
  },
  methods: {
    closeContainer() {
      this.$store.commit("editor/closeContainerOptions")
    },
    setValue(value) {
      const { blockId, role, path } = this.bind

      this.$store.dispatch("editor/overwriteBlockContent", {
        id: blockId,
        role,
        content: { [path]: value },
      })
      this.closeContainer()
    },
  },
  computed: {
    ...mapState({
      iframeRect: state => state.editor.containerOptions && state.editor.containerOptions.iframeRect,
      comp: state => state.editor.containerOptions && state.editor.containerOptions.component,
      bind: state => state.editor.containerOptions && state.editor.containerOptions.bind,
      target: state => state.editor.containerOptions && state.editor.containerOptions.target,
      // options: state => state.editor.containerOptions && state.editor.containerOptions,
    }),
    ...mapGetters({
      website: 'editor/website',
      pageContainers: 'editor/pageContainers',
    }),

    blockId() {
      return this.bind && this.bind.blockId
    },
    role() {
      return this.bind && this.bind.role
    },
    path() {
      return this.bind && this.bind.path
    },
    shouldCentralize() {
      return this.comp === "ImageManager"
    },
    dropdownPosition() {
      if (this.shouldCentralize) return {}
      const rect = this.iframeRect
      const target = this.target
      return target && rect && {
        left: (target.left + target.width + rect.left) + 'px',
        top: (target.top+ target.height + rect.top) + 'px',
      }
    },
    initialValue() {
      if (!this.pageContainers || !this.role) return null

      const blockId = this.blockId
      const blockBeingEdited = this.pageContainers[this.role].find(block => block.id === blockId)
      if (!blockBeingEdited) return;

      return blockBeingEdited.content && mapObject(blockBeingEdited.content)[this.path]
    },
  },
}

</script>
